import { Typography } from '@components/typography';
import { TableCell, TableRow } from '@mui/material';

export const GraphsListViewHeader = () => {
  return (
    <TableRow>
      <TableCell sx={{ width: '48px' }} />
      <TableCell sx={{ paddingLeft: '34px' }}>
        <Typography variant="caption2">Name</Typography>
      </TableCell>
      <TableCell>
        <Typography variant="caption2">Description</Typography>
      </TableCell>
      <TableCell>
        <Typography variant="caption2">Created</Typography>
      </TableCell>
      <TableCell>
        <Typography variant="caption2">Last modified</Typography>
      </TableCell>
      <TableCell>
        <Typography variant="caption2">Channel</Typography>
      </TableCell>
    </TableRow>
  );
};
